import * as React from 'react';
import { History } from 'history';
import Model from './quizquestion-model';
import BasePicklistCard from '../base/base-picklistcard.component';
import { align, size } from '../../services/app.service';

interface IProps { 
  history: History;
  caption?: string;
  nodataCaption?: string;
  sectionId?: number;
  pageSize?: number;
  paginationAlign?: align; 
  paginationSize?: size;
  paginationPrevCaption?: string;
  paginationNextCaption?: string;
  onLoad?: (data: any) => void;
  readOnly?: boolean;
  disablePagination?: boolean;
  disablePaginationButtonPage?: boolean;
  disablePaginationButtonPrev?: boolean;
  disableSearch?: boolean;  
  disableCard?: boolean;
  disableCardChild?: boolean;
  children?: React.ReactNode;
}

interface IState {
  children: React.ReactNode;
  header: any;
}

export default class QuizquestionPicklistCard extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      children: this.props.children,
      header: this.header(),
    }
  }
  
  private header() {
    return Model.columnPicklistCard.map((d: any) => d.type==='children'? {...d, name: 'datarowQuizquestion', children: this.props.children} : d )
  }
  
  private onLoad = (data: any) => {
    this.props.onLoad?.(data);
  }


  public componentDidUpdate() {
    if (this.props.children !== this.state.children)
      this.setState({ header: this.header(), children: this.props.children });
  }
  
  public render(): React.ReactNode {
    return (
      <BasePicklistCard history={this.props.history} caption={this.props.caption} nodataCaption={this.props.nodataCaption} endPointFilter={Model.endPointFilter+this.props.sectionId} model={Model} header={this.state.header} pageSize={this.props.pageSize} searchField={this.props.disableSearch? ' ' : ''} cardHeader swipe={this.props.disableSearch? 'vertical' : 'horizontal'} cardCount={this.props.disableSearch? 1 : 0} cardBorderWidth={this.props.disableCardChild? 0 : 1 } cardBoxShadow={this.props.children? 0 : 1} cardSpacing={2} paginationAlign={this.props.paginationAlign} paginationSize={this.props.paginationSize} paginationPrevCaption={this.props.paginationPrevCaption} paginationNextCaption={this.props.paginationNextCaption} onLoad={this.onLoad} autoLoad={this.props.disablePagination} autoUnselect readOnly={this.props.readOnly} disablePagination={this.props.disablePagination} disablePaginationButtonPage={this.props.disablePaginationButtonPage} disablePaginationButtonPrev={this.props.disablePaginationButtonPrev} disableBackButton disableCard={this.props.disableCard}/>
    );
  }
}
